/**
 * Created by karthikeyan.k on 11-10-2017.
 */
import { Injectable } from '@angular/core';
import { Istage } from '../../framework/Istage';
@Injectable()
export class CommonLayout {
  public static get PRELOADER(): Istage {
    return {
      stageWidth: 1280,
      stageHeight: 720,
      stageLeft: 0,
      stageTop: 0,
      stageZ: 1000,
      position: 'absolute',
      overflow: 'hidden',
    };
  }
  public static get PRELOADERPORTRAIT(): Istage {
    return {
      stageWidth: 720,
      stageHeight: 1280,
      stageLeft: 0,
      stageTop: 0,
      stageZ: 1000,
      position: 'absolute',
      overflow: 'hidden',
    };
  }
  public static get POPUPLAYOUT(): Istage {
    return {
      stageWidth: 1280,
      stageHeight: 720,
      stageLeft: 0,
      stageTop: 0,
      stageZ: 995,
      position: 'absolute',
      overflow: 'hidden',
    };
  }
  public static get POPUPLAYOUTPORTRAIT(): Istage {
    return {
      stageWidth: 720,
      stageHeight: 1280,
      stageLeft: 0,
      stageTop: 0,
      stageZ: 995,
      position: 'absolute',
      overflow: 'hidden',
    };
  }
  public static get BETTIMER(): Istage {
    return {
      stageWidth: 85,
      stageHeight: 85,
      stageLeft: 1080,
      stageTop: 564,
      stageZ: 61,
      position: 'absolute',
      overflow: 'hidden',
    };
  }
  public static get HELP(): Istage {
    return {
      stageWidth: 1280,
      stageHeight: 720,
      stageLeft: 0,
      stageTop: 0,
      stageZ: 78,
      position: 'absolute',
      overflow: 'hidden',
    };
  }

  public static get HELP_CONTENT(): Istage {
    return {
      stageWidth: 1280,
      stageHeight: 720,
      stageLeft: 0,
      stageTop: 0,
      stageZ: 1000,
      position: 'absolute',
      overflow: 'visible',
    };
  }
  public static get SETTINGS_CONTENT(): Istage {
    return {
      stageWidth: 815,
      stageHeight: 600,
      stageLeft: 230,
      stageTop: 35,
      stageZ: 79,
      position: 'absolute',
      overflow: 'hidden',
    };
  }
  public static get HELP_CLOSE(): Istage {
    return {
      stageWidth: 55,
      stageHeight: 55,
      stageLeft: 976,
      stageTop: 61,
      stageZ: 79,
      position: 'absolute',
      overflow: 'hidden',
    };
  }
  public static get HELP_ABOUTUS(): Istage {
    return {
      stageWidth: 399,
      stageHeight: 23,
      stageLeft: 564,
      stageTop: 298,
      stageZ: 80,
      position: 'absolute',
      overflow: 'hidden',
    };
  }
  public static get CHIPPICK(): Istage {
    return {
      stageWidth: 1280,
      stageHeight: 720,
      stageLeft: 0,
      stageTop: 0,
      stageZ: 77,
      position: 'absolute',
      overflow: 'hidden',
    };
  }
  public static get BLANKPAGE(): Istage {
    return {
      stageWidth: 1280,
      stageHeight: 728,
      stageLeft: 0,
      stageTop: -2,
      stageZ: 1001,
      position: 'absolute',
      overflow: 'hidden',
    };
  }
  /* public static get BGIMGAE():Istage { return {stageWidth:1471,stageHeight:1521,stageLeft:0,stageTop:-2,stageZ:-1001, position:'absolute', overflow: 'hidden'}};
   */

  /**************MOBILE - PORTRAIT***************/
  public static get CHIPPICKPORTRAIT(): Istage {
    return {
      stageWidth: 720,
      stageHeight: 1280,
      stageLeft: 0,
      stageTop: 0,
      stageZ: 77,
      position: 'absolute',
      overflow: 'hidden',
    };
  }

  public static get HELP_PORTRAIT(): Istage {
    return {
      stageWidth: 720,
      stageHeight: 1280,
      stageLeft: 0,
      stageTop: 0,
      stageZ: 78,
      position: 'absolute',
      overflow: 'hidden',
    };
  }

  public static get HELP_CONTENT_TUTORIAL_PORTRAIT(): Istage {
    return {
      stageWidth: 720,
      stageHeight: 526,
      stageLeft: 0,
      stageTop: 377,
      stageZ: 1000,
      position: 'absolute',
      overflow: 'visible',
    };
  }
  public static get HELP_CONTENT_PORTRAIT(): Istage {
    return {
      stageWidth: 720,
      stageHeight: 1280,
      stageLeft: 0,
      stageTop: 0,
      stageZ: 1000,
      position: 'absolute',
      overflow: 'visible',
    };
  }
  public static get HELP_CLOSE_PORTRAIT(): Istage {
    return {
      stageWidth: 55,
      stageHeight: 55,
      stageLeft: 648,
      stageTop: 400,
      stageZ: 79,
      position: 'absolute',
      overflow: 'hidden',
    };
  }
}
